import { Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";
import { APP_NUMBER_COURSE_IDS, COMM_ENG_COURSE_IDS, COMM_WLS_COURSE_IDS, DIGITAL_LIT_COURSE_IDS, DIGITAL_LIT_SA_COURSE_ID, ESOL_COURSE_IDS } from "../constants/CourseResources";

@Pipe({
  name: "courseIconPipe",
})
export class CourseIconIdentifierPipe implements PipeTransform {
  transform(courseId: number, size: string): string {
    /** Current sizes : sm, md */
    let hyphenSize = AppConstants.SECTION_DELIM + size;

    switch (courseId) {
      case APP_NUMBER_COURSE_IDS.find(e => e == courseId):
        return AppConstants.APP_NUM + hyphenSize;
      
      case COMM_ENG_COURSE_IDS.find(e => e == courseId):
        return AppConstants.COM_ENG + hyphenSize;
      
      case COMM_WLS_COURSE_IDS.find(e => e == courseId):
        return AppConstants.COM_WEL + hyphenSize;
        
      case DIGITAL_LIT_COURSE_IDS.find(e => e == courseId):
        return AppConstants.DIG_LIT + hyphenSize;
      
      case ESOL_COURSE_IDS.find(e => e == courseId):
        return AppConstants.ESOL + hyphenSize;

      case DIGITAL_LIT_SA_COURSE_ID.find(e => e == courseId):
        return AppConstants.DIG_LIT_SA + hyphenSize;
      default:
        break;
    }
  }
}